import Typography from "@mui/material/Typography"
import { useStateSelector } from 'shared/store/hooks';

export const UserTopBarAvatar = () => {
  const { user } = useStateSelector(store => store.auth);
  return (
    <div>
      <Typography fontWeight={500}>{user?.firstName} {user?.secondName}</Typography>
      {/* <IconButton color="inherit">
        <NotificationsIcon />
      </IconButton> */}
      {/* <Typography fontWeight = {500}>{user?.firstName} {user?.secondName}</Typography> */}
      {/* <IconButton color="inherit" onClick={logout}>
        <LogoutIcon />
      </IconButton> */}
    </div>
  )
}